import Navbar from "../../components/Navbar/Navbar"
import LazyImage from "../../components/LazyImage/LazyImage"
import r from "../../images/types_mosaic_r.webp"
import h from "../../images/types_mosaic_h.webp"
import g from "../../images/types_mosiac_g.webp"
import "../../styles.css"
export default function Mosaic (){
    return(
        <div>
            <Navbar />
            <h2 className="project-page-title">Mosaic Letters</h2>
            <div className="bio">
                <p className="regular">I did this series in the spring of 2023. This was inspired by the Taiwanese mosaics you often see on old vintage buildings.
                I hope to extend this series once I gather some more inspiration for mosaics in Chiayi.
                </p>
                <br></br>
            </div>
            <div className="two-column-imgs">
                <LazyImage src={g} alt="g"/>
                <LazyImage src={h} alt="h"/>
            </div>
            <div className="two-column-imgs">
                <LazyImage src={r} alt="r"/>
                
            </div>
        </div>
    )
}
